import { useId } from "react";

import type {
  TUseFieldset,
  TUseFieldsetProps,
} from "@/ui/components/form/Fieldset/Fieldset.config";

export const useFieldset = ({
  ariaDescribedBy,
  error,
  errorId,
  labelId,
}: TUseFieldsetProps): TUseFieldset => {
  const generatedId = useId();
  const resolvedErrorId = errorId ?? `${generatedId}-error`;
  const describedBy = [
    ariaDescribedBy,
    error ? resolvedErrorId : undefined,
  ].filter(Boolean).join(" ") || undefined;

  return {
    describedBy,
    errorId: resolvedErrorId,
    labelId: labelId ?? `${generatedId}-label`,
  };
};
